<template>
  <section id="payment">
    <div class="w-full px-4 pt-0 mx-auto md:px-10">
      <div class="flex flex-col w-full px-4">
        <div class="overflow-x-auto">
          <div class="flex flex-wrap py-6">
            <div class="relative flex-1 flex-grow w-full max-w-full pr-4">
              <span class="text-2xl font-semibold text-gray-800">
                {{ "SectionTitle_Payment" | i18n }}
              </span>
            </div>
            <div class="relative flex-initial w-auto ml-auto">
              <ButtonPrimary
                class="mr-4"
                @click-primary="handleSubmit"
              >
                {{ "Button_Publish" | i18n }}
              </ButtonPrimary>
              <ButtonSecondary
                :is-active="id ? true : false"
                @click-secondary="handleDelete(id)"
              >
                {{ "Button_Delete" | i18n }}
              </ButtonSecondary>
            </div>
          </div>
          <section id="payment-form">
            <div class="min-w-full space-y-8 align-middle">
              <div
                class="px-6 py-10 space-y-5 bg-white border-0 shadow-lg rounded-3xl"
              >
                <div class="relative z-0 w-full">
                  <select
                    v-model="courseId"
                    name="select"
                    :v="courseId"
                    class="block w-full px-0 mt-0 bg-transparent border-0 border-b-2 appearance-none z-1 focus:outline-none focus:ring-0 focus:border-black"
                    :class="[
                      $v.courseId.$error ? 'border-red-600' : 'border-gray-200'
                    ]"
                  >
                    <option
                      value=""
                      selected
                      disabled
                      hidden
                    />
                    <option
                      v-for="c in courses"
                      :key="c.courseId"
                      :value="c.courseId"
                    >
                      {{ c.name }}
                    </option>
                  </select>
                  <label
                    for="select"
                    class="absolute duration-300 top-3 -z-1 origin-0"
                    :class="
                      $v.courseId.$error ? 'text-red-600' : 'text-gray-500'
                    "
                  >
                    {{ "InputLabel_SelectCourse" | i18n }}
                  </label>
                  <span
                    v-if="$v.courseId.$dirty && !$v.courseId.required"
                    class="text-sm text-red-600"
                  >
                    {{ "InputError_EmptyCourse" | i18n }}
                  </span>
                </div>

                <div class="relative z-0 w-full">
                  <input
                    v-model.trim="userEmail"
                    type="text"
                    name="userEmail"
                    placeholder=" "
                    class="block w-full px-0 mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-black"
                    :class="
                      $v.userEmail.$error ? 'border-red-600' : 'border-gray-200'
                    "
                  >
                  <label
                    for="userEmail"
                    class="absolute duration-300 top-3 -z-1 origin-0"
                    :class="
                      $v.userEmail.$error ? 'text-red-600' : 'text-gray-500'
                    "
                  >
                    {{ "InputLabel_EnterUserEmail" | i18n }}
                  </label>
                  <span
                    v-if="$v.userEmail.$error"
                    class="text-sm text-red-600"
                  >
                    {{ "InputError_EmptyEmail" | i18n }}
                  </span>
                  <span
                    v-else-if="$v.userEmail.$dirty"
                    class="text-sm text-red-600"
                  >
                    {{ "InputError_EmailNotExists" | i18n }}
                  </span>
                </div>

                <div class="relative z-0 w-full">
                  <input
                    v-model.number="cost"
                    type="number"
                    name="cost"
                    placeholder=" "
                    class="block w-full px-0 mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-black"
                    :class="
                      $v.cost.$error ? 'border-red-600' : 'border-gray-200'
                    "
                  >
                  <div class="absolute top-0 right-0 mt-3 mr-4 text-gray-400">
                    {{ "Currency" | i18n }}
                  </div>
                  <label
                    for="cost"
                    class="absolute duration-300 top-3 -z-1 origin-0"
                    :class="$v.cost.$error ? 'text-red-600' : 'text-gray-500'"
                  >
                    {{ "InputLabel_EnterCost" | i18n }}
                  </label>
                  <span
                    v-if="$v.cost.$dirty && !$v.cost.required"
                    class="text-sm text-red-600"
                  >
                    {{ "InputError_EmptyCost" | i18n }}
                  </span>
                </div>

                <div class="flex flex-row space-x-4">
                  <div class="relative z-0 w-full">
                    <input
                      v-model="payAt.date"
                      :type="payAt.date ? 'date' : 'text'"
                      name="date"
                      placeholder=" "
                      class="block w-full px-0 mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-black"
                      :class="
                        $v.payAt.date.$error
                          ? 'border-red-600'
                          : 'border-gray-200'
                      "
                      @click="e => e.target.setAttribute('type', 'date')"
                    >
                    <label
                      for="date"
                      class="absolute duration-300 top-3 -z-1 origin-0"
                      :class="
                        $v.payAt.date.$error ? 'text-red-600' : 'text-gray-500'
                      "
                    >
                      {{ "InputLabel_EnterPaymentDate" | i18n }}
                    </label>
                    <span
                      v-if="$v.payAt.date.$dirty && !$v.payAt.date.required"
                      class="text-sm text-red-600"
                    >
                      {{ "InputError_EmptyDate" | i18n }}
                    </span>
                  </div>
                  <div class="relative z-0 w-full">
                    <input
                      v-model="payAt.time"
                      :type="payAt.time ? 'time' : 'text'"
                      name="time"
                      placeholder=" "
                      class="block w-full px-0 mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-black"
                      :class="
                        $v.payAt.time.$error
                          ? 'border-red-600'
                          : 'border-gray-200'
                      "
                      @click="e => e.target.setAttribute('type', 'time')"
                    >
                    <label
                      for="time"
                      class="absolute duration-300 top-3 -z-1 origin-0"
                      :class="
                        $v.payAt.time.$error ? 'text-red-600' : 'text-gray-500'
                      "
                    >
                      {{ "InputLabel_EnterPaymentTime" | i18n }}
                    </label>
                    <span
                      v-if="$v.payAt.time.$dirty && !$v.payAt.time.required"
                      class="text-sm text-red-600"
                    >
                      {{ "InputError_EmptyTime" | i18n }}
                    </span>
                  </div>
                </div>
              </div>

              <div>
                <div
                  v-if="createdAt"
                  class="mb-3"
                >
                  <p>
                    {{ "Published" | i18n }}:
                    {{ createdAt | date("dd, DD MMM YYYY, HH:mm:ss") }}
                  </p>
                  <p>{{ "Author" | i18n }}: {{ createdBy }}</p>
                </div>
                <div
                  v-if="updatedAt"
                  class=""
                >
                  <p>
                    {{ "LastEdit" | i18n }}:
                    {{ updatedAt | date("dd, DD MMM YYYY, HH:mm:ss") }}
                  </p>
                  <p>{{ "Editor" | i18n }}: {{ updatedBy }}</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import { required, email } from "vuelidate/lib/validators";

import i18nFilter from "@/filters/i18n.filter";

import ButtonPrimary from "@/components/BaseButtonPrimary.vue";
import ButtonSecondary from "@/components/BaseButtonSecondary.vue";

export default {
  name: "PaymentPage",

  components: { ButtonPrimary, ButtonSecondary },

  data: () => ({
    id: "",
    courses: [],
    courseId: "",
    userEmail: "",
    payAt: {
      date: new Date().toISOString().substring(0, 10),
      time: new Date().toISOString().substring(11, 19)
    },
    cost: "",
    createdBy: "",
    createdAt: "",
    updatedBy: "",
    updatedAt: ""
  }),

  validations() {
    let v = {
      courseId: { required },
      userEmail: { email, required },
      payAt: { date: { required }, time: { required } },
      cost: { required }
    };
    return v;
  },

  async mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.id = id;
      const paymentData = await this.fetchPaymentById(id);
      this.populateData(paymentData);
    }
    this.courses = await this.fetchAllCourses();
  },

  methods: {
    ...mapActions([
      "fetchAllCourses",
      "fetchPaymentById",
      "fetchUserByEmail",
      "submitPayment",
      "deletePaymentById"
    ]),
    ...mapMutations(["setError"]),
    populateData(payment) {
      this.courseId = payment.course.courseId || "";
      this.userEmail = payment.userEmail || "";
      this.payAt = payment.payAt || "";
      this.cost = payment.cost || "";
      this.createdBy = payment.createdBy || "";
      this.createdAt = payment.createdAt ? payment.createdAt.toDate() : "";
      this.updatedBy = payment.updatedBy || "";
      this.updatedAt = payment.updatedAt ? payment.updatedAt.toDate() : "";
    },
    async handleSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        this.setError("form/missing-some-fields");
        return;
      }

      const { id, courseId, userEmail, payAt, cost } = this;

      const userId = await this.fetchUserByEmail(userEmail);
      if (!userId) return this.$v.userEmail.$touch();

      let payment = { cost, userEmail, userId, course: { courseId } };

      // Modify payment data
      if (id) payment.paymentId = id;
      payment.payAt = new Date(payAt.date + "T" + payAt.time);

      try {
        await this.submitPayment(payment);
        this.$router.push("/admin/payments");
      } catch (error) {
        this.$logger.log(error);
      }
    },
    async handleDelete(paymentId) {
      if (confirm(i18nFilter("Question_Delete"))) {
        this.deletePaymentById(paymentId);
        this.$router.push("/admin/payments");
      }
    }
  }
};
</script>

<style></style>
